import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Link from 'next/link';
import classNames from 'classnames';
import style from './Footer.module.scss';

export const FooterLink: React.FC<{
  children: JSX.Element | string;
  to: string;
}> = ({ children, to }) => (
  <li className="py-2">
    <Link legacyBehavior href={to} passHref>
      <a>{children}</a>
    </Link>
  </li>
);

export const FooterLinks: React.FC = () => (
  <ul className={classNames('list-unstyled', style.links)}>
    <FooterLink to="/pricing">
      <FormattedMessage id="web.nav.pricing" defaultMessage="Pricing" />
    </FooterLink>
    <FooterLink to="/privacy-policy">
      <FormattedMessage id="web.footer.privacy-policy" defaultMessage="Privacy Policy" />
    </FooterLink>
    <FooterLink to="/refund-policy">
      <FormattedMessage id="web.footer.refund-policy" defaultMessage="Refund Policy" />
    </FooterLink>
    <FooterLink to="/terms-of-service">
      <FormattedMessage id="web.footer.terms-of-service" defaultMessage="Terms of Service" />
    </FooterLink>
    <FooterLink to="/imprint">
      <FormattedMessage id="web.footer.imprint" defaultMessage="Imprint" />
    </FooterLink>
    {/* <FooterLink to="/blog"> */}
    {/*  <FormattedMessage id="web.nav.blog" defaultMessage="Blog" /> */}
    {/* </FooterLink> */}
    {/* <FooterLink to="/press-kit"> */}
    {/*  <FormattedMessage id="web.nav.press-kit" defaultMessage="Press Kit" /> */}
    {/* </FooterLink> */}
  </ul>
);

export const Footer: React.FC = () => {
  const intl = useIntl();
  return (
    <footer className={style.footer}>
      <div className="container py-5">
        <div className={style.footerContent}>
          <div className={style.footerBrand}>
            <h3 className={style.brandName}>TeslaEesti</h3>
            <p className={style.brandTagline}>
              Your source for Tesla registration data in Estonia
            </p>
          </div>
          <div className={style.footerContact}>
            <p className={style.contactLabel}>Contact</p>
            <a href="mailto:bartosz@hernas.com" className={style.contactLink}>bartosz@hernas.com</a>
          </div>
        </div>
        <div className={style.footerBottom}>
          <div className={style.copyright}>
            {intl.formatMessage(
              {
                id: 'web.footer.rights',
                defaultMessage: '©{date} TeslaEesti.com'
              },
              { date: new Date().getFullYear() }
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
